/**
 * The signed-in frame while the session restores (refresh + whoami + org,
 * 1–2 s on a cold load). It used to be a blank page reading "Signing you
 * in…"; now the rail and top bar are where they will be and the content area
 * shows placeholder blocks, so the page does not jump when it arrives. The
 * role is not known yet, so the rail shows neutral bars, not links that might
 * not exist for this member.
 */
export function ShellSkeleton() {
  return (
    <div className="shell" aria-busy="true">
      <aside className="rail" aria-hidden="true">
        <span className="brand">
          <span className="sk sk-mark" />
          <span>
            FinderlyFix
            <small>Partners</small>
          </span>
        </span>
        {[5, 2, 5, 4].map((n, i) => (
          <div className="rail-section" key={i}>
            <span className="sk sk-rail sk-rail-h" />
            {Array.from({ length: n }, (_, j) => (
              <span className="sk sk-rail" key={j} style={{ width: `${60 + ((i * 7 + j * 13) % 30)}%` }} />
            ))}
          </div>
        ))}
      </aside>
      <div className="main">
        <header className="topbar" aria-hidden="true">
          <span className="sk" style={{ width: 160, height: 28 }} />
          <span className="grow" />
          <span className="sk" style={{ width: 90, height: 24, borderRadius: 999 }} />
        </header>
        <main id="main" className="content" tabIndex={-1}>
          <div role="status" aria-live="polite" className="visually-hidden">
            Signing you in…
          </div>
          <div className="stack-lg" aria-hidden="true">
            <div className="stack-sm">
              <span className="sk" style={{ width: 220, height: 28 }} />
              <span className="sk" style={{ width: 'min(420px, 90%)', height: 14 }} />
            </div>
            <span className="sk sk-block" style={{ height: 96 }} />
            <div className="grid-2">
              <span className="sk sk-block" style={{ height: 200 }} />
              <span className="sk sk-block" style={{ height: 200 }} />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
